import React, { FC } from "react";
import "../../assets/style/3_components/c-playbackInformation.scss";
import { CodeIcon } from "../icons";
import { PartDebugInfoParameter } from "../../model/playerConfiguration/DebugPartInfo";

type Props = {
  parameters: PartDebugInfoParameter[];
};

const ParameterRow = ({ parameter }: { parameter: PartDebugInfoParameter }) => {
  return (
    <tr>
      <td key={parameter.name + "-k"}>
        <div className="c-debugParameters__value">
          {parameter.html ? <CodeIcon width={20} height={20} /> : ""}
          {parameter.name}
        </div>
      </td>
      <td key={parameter.name + "-v"}>{parameter.value}</td>
    </tr>
  );
};

export const DebugVariables: FC<Props> = (props) => {
  const { parameters } = props;

  return (
    <table className={"c-debugInformation--parameters"}>
      <thead className="c-debugInformation--parametersHeader">
        <tr>
          <th>Parameter name</th>
          <th>Value</th>
        </tr>
      </thead>

      <tbody className="c-debugInformation--parametersBody">
        {parameters.length > 0 ? (
          parameters.map((parameter) => <ParameterRow parameter={parameter} />)
        ) : (
          <span style={{ fontStyle: "italic" }}>No parameters</span>
        )}
      </tbody>
    </table>
  );
};
